import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

export default () => {
  const containers = document.querySelectorAll('.js-video-popup')
  if (containers.length < 1) return
  ;[...containers].forEach(container => {
    const thumbnails = document.querySelectorAll(
      '.c-featured-videos__video-row'
    )
    const closeButton = container.querySelector('.js-close-button')
    const video = container.querySelector('.js-video')
    const playButton = container.querySelector('.js-video-play')
    const overlay = container.querySelector('.js-video-overlay')

    let source = document.createElement('source')

    if (closeButton) {
      closeButton.addEventListener('click', () => {
        enableBodyScroll(container)
        container.classList.toggle('c-featured-videos__video-container--active')
        source.remove()
        video.pause()
        playButton.classList.remove('hidden')
        overlay.classList.remove('hidden')
      })
    }

    ;[...thumbnails].forEach(function(thumbnail, index) {
      thumbnail.querySelector('.c-button').addEventListener('click', () => {
        disableBodyScroll(container)
        event.preventDefault()
        container.classList.toggle('c-featured-videos__video-container--active')
        source.setAttribute('src', thumbnail.getAttribute('url'))
        video.appendChild(source)
        video.load()
      })
    })
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/VideoPopup.js